import { render, staticRenderFns } from "./ThemesEditorEditBtn.vue?vue&type=template&id=255b8cd4&scoped=true"
import script from "./ThemesEditorEditBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemesEditorEditBtn.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ThemesEditorEditBtn.vue?vue&type=style&index=0&id=255b8cd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255b8cd4",
  null
  
)

export default component.exports